import { Box, List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormattedObjectType, TabsType } from 'components/Sidebar/types';
import SidebarItem from '../SidebarItem';

type ArchiveProps = {
    activeTab: TabsType;
    archiveItems: FormattedObjectType[];
    closeSidebar: () => void;
    onOpenROneModal: (jobOrderId?: string) => void;
};

export const Archive = ({
    activeTab,
    archiveItems,
    closeSidebar,
    onOpenROneModal,
}: ArchiveProps) => {
    const { t } = useTranslation();

    return (
        <Box className="history">
            {archiveItems.length === 0 && (
                <Box className="sidebar-empty-message">
                    {t('web_app.left_sidebar.empty_message')}
                </Box>
            )}
            {archiveItems.map((context) => (
                <Box className="history-item" key={context.id}>
                    <Box className="flex">
                        <Box className="month">{context.id}</Box>
                        <Box> {context.year}</Box>
                    </Box>
                    <List>
                        {context.items.map((state) => (
                            <SidebarItem
                                item={state}
                                key={`${activeTab}-${state.document_id}`}
                                closeBar={closeSidebar}
                                onOpenROneModal={onOpenROneModal}
                            />
                        ))}
                    </List>
                </Box>
            ))}
        </Box>
    );
};
